import type { RefineThemedLayoutV2HeaderProps } from '@refinedev/antd'
import { useGetIdentity } from '@refinedev/core'
import {
  Layout as AntdLayout,
  Avatar,
  Space,
  Switch,
  Typography,
  theme
} from 'antd'
import type React from 'react'
import { useContext } from 'react'
import { ColorModeContext } from '../../contexts/color-mode'
import { SunOutlined, MoonOutlined } from '@ant-design/icons'

const { Text } = Typography
const { useToken } = theme

interface User {
  name: string
  avatar: string
}

export const Header: React.FC<RefineThemedLayoutV2HeaderProps> = ({
  sticky
}) => {
  const { token } = useToken()
  const { data: user } = useGetIdentity<User>()
  const context = useContext(ColorModeContext)

  // Ensure context exists to satisfy type safety, though it should always exist inside Provider
  const { mode, toggleTheme } = context ?? { mode: 'light', toggleTheme: () => { } }

  const headerStyles: React.CSSProperties = {
    backgroundColor: token.colorBgElevated,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0px 24px',
    height: '64px'
  }

  if (sticky) {
    headerStyles.position = 'sticky'
    headerStyles.top = 0
    headerStyles.zIndex = 1
  }

  return (
    <AntdLayout.Header style={headerStyles}>
      <Space>
        <Switch
          checkedChildren={<MoonOutlined />}
          unCheckedChildren={<SunOutlined />}
          onChange={() => { toggleTheme() }}
          checked={mode === 'dark'}
        />
        {(user?.name ?? user?.avatar) && (
          <Space style={{ marginLeft: '8px' }} size='middle'>
            {user?.name && <Text strong>{user.name}</Text>}
            {user?.avatar && <Avatar src={user?.avatar} alt={user?.name} />}
          </Space>
        )}
      </Space>
    </AntdLayout.Header>
  )
}
